import { Button, Modal } from '@atom/mui';

import classes from './createWorkModal.module.css';

const styles = {
  cancelButton: {
    marginRight: '0.5rem',
  },
};

type BulkCreateConfirmModalProps = {
  open: boolean;
  loading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

const BulkCreateConfirmModal = (props: BulkCreateConfirmModalProps) => {
  const { open, loading, onCancel, onConfirm } = props;

  const footer = (
    <div>
      <Button
        onClick={onCancel}
        style={styles.cancelButton}
        data-cy="createWorkModalBulkConfirmCancelButton"
      >
        Cancel
      </Button>
      <Button
        color="primary"
        variant="contained"
        onClick={onConfirm}
        disabled={loading}
        data-cy="createWorkModalBulkConfirmCreateButton"
      >
        Create
      </Button>
    </div>
  );

  return (
    <Modal
      title="Create Multiple Work?"
      open={open}
      footer={footer}
      loading={loading}
      data-cy="createWorkModalBulkConfirm"
    >
      <div className={classes.guardContent}>
        This action will create multiple work. Are you sure?
      </div>
    </Modal>
  );
};

export default BulkCreateConfirmModal;
